import { ViewSupport46Container } from "../../../containers/SupportSystem/ViewReports/ViewSupport46Container"
export function ViewSupport46Page() {
    return (
        <ViewSupport46Container />
    )
}